export type KeyboardInsetState = {
  /** Pixels covered by the on-screen keyboard at the bottom of the layout viewport. */
  bottomInset: number;
  /** Usable viewport height above the keyboard in CSS pixels. */
  height: number;
};

export function computeVisualViewportInset(
  layoutViewportHeight: number,
  visualViewportHeight: number,
  visualViewportOffsetTop: number,
): KeyboardInsetState {
  const bottomInset = Math.max(
    0,
    Math.round(layoutViewportHeight - visualViewportHeight - visualViewportOffsetTop),
  );
  return {
    bottomInset,
    height: bottomInset > 0 ? layoutViewportHeight - bottomInset : layoutViewportHeight,
  };
}

export function computeCapacitorKeyboardInset(
  keyboardHeight: number,
  layoutViewportHeight: number,
): KeyboardInsetState {
  const bottomInset = Math.max(0, Math.round(keyboardHeight));
  return {
    bottomInset,
    height: Math.max(0, layoutViewportHeight - bottomInset),
  };
}

export function keyboardAwareSheetMaxHeight(
  maxHeight: string,
  state: KeyboardInsetState,
  minHeight = 180,
): string {
  if (state.bottomInset <= 0) return maxHeight;
  return `min(${maxHeight}, ${Math.max(minHeight, Math.floor(state.height - 12))}px)`;
}

export function keyboardAwareOverlayPadding(bottomInset: number): number | undefined {
  return bottomInset > 0 ? bottomInset : undefined;
}
